import { SearchCategory, SearchResultsByCategory } from '@/lib/models/Search';

export function getCategories(results: SearchResultsByCategory): { key: SearchCategory; count: number }[] {
  return [
    { key: 'all', count: results.all.count },
    { key: 'knowledgebase', count: results.knowledgebase.count },
    { key: 'documentation', count: results.documentation.count },
    { key: 'templates', count: results.templates.count },
  ];
}
